const QUESTION_PAGE = 'QUESTION_PAGE';
const WELCOME_PAGE = 'WELCOME_PAGE';
const THANK_YOU_PAGE = 'THANK_YOU_PAGE';
const END_OF_SURVEY_PAGE = 'END_OF_SURVEY_PAGE'; // empty page with submit button
const REDIRECT = 'REDIRECT';
const SCREEN_OUT = 'SCREEN_OUT';

export const PAGE_TYPES = {
  QUESTION_PAGE,
  WELCOME_PAGE,
  THANK_YOU_PAGE,
  END_OF_SURVEY_PAGE,
  REDIRECT,
  SCREEN_OUT,
};
